export default {"src":"/_next/static/media/gmr.9934681a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};